import { countApiTemplate } from "./apis/count";
import { listApiTemplate } from "./apis/list";
import deepFreeze from 'deep-freeze-strict';
import { getApiTemplate } from "./apis/get";
import { collectionConstructorFactory } from "../collection/collectionConstructorFactory";
const template = {
  apiTemplates: [listApiTemplate, getApiTemplate, countApiTemplate],
  name: 'DB-多表查询',
  templateId: 'universal_read',
  desc: '用于生成列表或表单类型的一系列组件，但是只有读数据的能力',
  entity: {
    defaults: [{
      cgiName: 'list',
      path: [{
        id: 'data',
        type: 'fields'
      }, {
        type: 'items'
      }]
    }, {
      cgiName: 'get',
      path: [{
        id: 'data',
        type: 'fields'
      }]
    }]
  }
};
export const UniversalReadTemplate = deepFreeze(template);
export const UniversalReadCollection = collectionConstructorFactory(UniversalReadTemplate);
export const universalReadApis = UniversalReadTemplate.apiTemplates.map(item => item.name);
//# sourceMappingURL=UniversalRead.js.map
